// eslint-disable-next-line import/prefer-default-export
export const targetName = {
  DEV: 'DEV',
  STAG: 'STAG',
  PRO: 'PROD',
};
